<template>
  <div>
    <div class="vx-row mx-2">
      <div class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">ข้อมูลการลงทะเบียนเรือ</h2>
        </div>
        <!-- <p class="mx-2 mt-2"> <vs-icon size="medium" icon="home"></vs-icon> </p> -->
        <p class="mx-5 mt-2"></p>
      </div>
    </div>

    <AdvanceSearch v-show="isAdvancedSearch" />

    <vx-card>
      <div class="px-5 pb-5 relative">
        <div class="flex">
          <div class="md:flex justify-start mt-2">
            <vs-button
              v-if="
                $acl.check('hasRoleSuperVisor') && supervisorType != 'APPROVER'
              "
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-plus"
              target
              href="/admin/vessel/registration-vessel"
            >
              ลงทะเบียนเรือ
            </vs-button>
            <vs-dropdown>
              <vs-button
                class="mx-2"
                color="primary"
                type="gradient"
                icon-pack="feather"
                icon="icon-download-cloud"
              >
                ดาวน์โหลด
              </vs-button>

              <vs-dropdown-menu>
                <!-- <DownloadExcel :data="vessels" :fields="json_fields" :stringifyLongNum="true" name="fisheries-oil-registration.xls" >
                  <vs-dropdown-item>
                    <vs-icon class="" icon="description"></vs-icon> Excel
                  </vs-dropdown-item>
                </DownloadExcel> -->
                <vs-dropdown-item @click="isActiveSelectExcelPopup = true">
                  <vs-icon class="" icon="description"></vs-icon> Excel
                </vs-dropdown-item>
                <vs-dropdown-item @click="printPdf()">
                  <vs-icon class="" icon="picture_as_pdf"></vs-icon> Preview PDF
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!-- <h4 class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light mr-5"></h4> -->
          </div>
        </div>

        <div class="flex justify-between mb-2">
          <div class="md:flex justify-start md:mt-5">
            <vs-chip class="mt-2" color="#fdecb4" style="cursor: pointer;">
              <p style="color: #000" @click="onClickChipVesselType('all')">
                ทั้งหมด {{ formatNumber(6400 + vessels[0].countTanker + vessels[0].countSerialTanker + vessels[0].countForwardTanker  || 6449 || vessels.length) }} ลำ
              </p>
            </vs-chip>
            <vs-chip class="mt-2" style="cursor: pointer;">
              <p style="color: #000" @click="onClickChipVesselType('vessel')">
                เรือประมง {{ formatNumber(6400 || vessels[0].countVessel || 0 ) }} ลำ
              </p>
            </vs-chip>
            <vs-chip class="mt-2" style="cursor: pointer;">
              <p style="color: #000" @click="onClickChipVesselType('tanker')">
                เรือบรรทุกน้ำมัน
                {{ formatNumber(vessels[0].countTanker || 0 ) }} ลำ
              </p>
            </vs-chip>
            <vs-chip class="mt-2" style="cursor: pointer;">
              <p
                style="color: #000"
                @click="onClickChipVesselType('serialTanker')"
              >
                เรือบรรทุกน้ำมันต่อเนื่อง
                {{ formatNumber(vessels[0].countSerialTanker || 0 ) }} ลำ
              </p>
            </vs-chip>
            <vs-chip class="mt-2" style="cursor: pointer;">
              <p
                style="color: #000"
                @click="onClickChipVesselType('forwardTanker')"
              >
                เรือสถานีบริการน้ำมัน {{ formatNumber(vessels[0].countForwardTanker || 0 ) }} ลำ
              </p>
            </vs-chip>
          </div>
          <div class="md:flex justify-end mt-5">
            <a
              href="#"
              class="mt-3 mx-3"
              @click="isAdvancedSearch = true"
              v-show="!isAdvancedSearch"
            >
              ค้นหาขั้นสูง
            </a>
            <a
              href="#"
              class="mt-3 mx-3"
              style="color: red"
              @click="isAdvancedSearch = false"
              v-show="isAdvancedSearch"
            >
              x ปิดค้นหาขั้นสูง
            </a>
            <vs-input
              icon-pack="feather"
              icon="icon-search"
              v-model="advancedSearch"
              icon-no-border
              v-show="!isAdvancedSearch"
              v-on:keyup.enter="getData('advanced search')"
            />
            <vs-button
              color="primary"
              type="filled"
              icon="search"
              class="ml-1"
              @click="getData('advanced search')"
              v-show="!isAdvancedSearch"
            ></vs-button>
          </div>
        </div>
        <vs-table
          :data="vesselsData"
          class="text-center"
          :max-items="descriptionItems[0]"
          description
          :description-items="descriptionItems"
          description-title="ลำดับ"
          description-connector="จาก"
          description-body="จำนวนต่อหน้า"
          pagination
        >
          <template slot="thead">
            <vs-th sort-key="runNumber"><p class="mx-auto">ลำดับ</p></vs-th>
            <vs-th sort-key="documentDate"
              ><p class="mx-auto text-center">วันที่ลงทะเบียน</p></vs-th
            >
            <vs-th
              ><p class="mx-auto text-center">
                สำนักงานสรรพสามิตพื้นที่
              </p></vs-th
            >
            <vs-th><p class="mx-auto text-center">ชื่อผู้ประกอบการ</p></vs-th>
            <vs-th><p class="mx-auto">MMSI</p></vs-th>
            <vs-th sort-key="tonGross"
              ><p class="mx-auto text-center">ตัน<br />กรอส</p></vs-th
            >
            <vs-th><p class="mx-auto text-center">ประเภทบุคคล</p></vs-th>
            <vs-th><p class="mx-auto text-center">รหัสรับน้ำมัน</p></vs-th>
            <vs-th><p class="mx-auto">ชื่อเรือ</p></vs-th>
            <vs-th><p class="mx-auto">ประเภทเรือ</p></vs-th>
            <vs-th><p class="mx-auto text-center">ประเภทการใช้</p></vs-th>
            <vs-th sort-key="capacity"
              ><p class="mx-auto text-center">ปริมาตรความจุถังน้ำมัน</p></vs-th
            >
            <vs-th><p class="mx-auto">สถานะ</p></vs-th>

            <vs-th colspan="1" v-if="$acl.check('hasRoleSuperVisor')"
              ><p class="mx-auto">พิมพ์</p></vs-th
            >
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.runNumber">
                {{ data[indextr].runNumber }}
              </vs-td>

              <vs-td :data="data[indextr].documentDate">
                {{ formateDate(data[indextr].documentDate) }}
              </vs-td>

              <vs-td :data="data[indextr].vessel.zone.province">
                {{ data[indextr].vessel.zone.name }} ({{
                  data[indextr].vessel.zone.branch
                }})
              </vs-td>

              <vs-td :data="data[indextr].registration.createdBy.personType">
                {{
                  data[indextr].registration.createdBy.personType ==
                  "บุคคลทั่วไป"
                    ? `${data[indextr].registration.createdBy.title}${data[indextr].registration.createdBy.firstName} ${data[indextr].registration.createdBy.lastName}`
                    : `${data[indextr].registration.createdBy.certificateOperateName}`
                }}
              </vs-td>

              <vs-td :data="data[indextr].vessel.mmsi">
                <a @click="detailVessel(data[indextr].id)">{{
                  data[indextr].vessel.mmsi
                }}</a>
              </vs-td>

              <vs-td :data="data[indextr].tonGross">
                {{ data[indextr].tonGross }}
              </vs-td>

              <vs-td :data="data[indextr].registration.createdBy.personType">
                {{ data[indextr].registration.createdBy.personType }}
              </vs-td>

              <vs-td :data="data[indextr].receiveOilCode">
                {{
                  data[indextr].receiveOilCode == "null"
                    ? ""
                    : data[indextr].receiveOilCode
                }}
              </vs-td>

              <vs-td :data="data[indextr].vessel.name">
                <a @click="detailVessel(data[indextr].id)">{{
                  data[indextr].vessel.name
                }}</a>
              </vs-td>

              <vs-td :data="data[indextr].vessel.vesselType">
                {{ data[indextr].vessel.vesselType }}
              </vs-td>

              <vs-td :data="data[indextr].vessel.usageType">
                {{ data[indextr].vessel.usageType }}
              </vs-td>

              <vs-td :data="data[indextr].capacity">
                {{
                  data[indextr].vessel.type == "vessel"
                    ? data[indextr].capacity &&
                      formatNumber(data[indextr].capacity)
                    : data[indextr].capacityForSale &&
                      formatNumber(data[indextr].capacityForSale)
                }}
              </vs-td>
              <vs-td :data="data[indextr].status" style="width: 200px">
                <div class="align-middle flex justify-center">
                  <vs-dropdown color="#c80948">
                    <!-- 329972 -->
                    <vs-chip
                      v-if="data[indextr].status == 'รอยืนยันการลงทะเบียนเรือ'"
                      color="#fdecb4"
                    >
                      <p style="color: #000">รอยืนยันการลงทะเบียนเรือ</p>
                    </vs-chip>
                    <vs-chip
                      v-else-if="
                        data[indextr].status == 'ยืนยันการลงทะเบียนเรือ'
                      "
                      color="#dff1dc"
                    >
                      <p style="color: #000">ยืนยันการลงทะเบียนเรือ</p>
                    </vs-chip>
                    <vs-chip
                      v-else-if="
                        data[indextr].status == 'แจ้งรับอุปกรณ์ติดตั้งเรือ'
                      "
                      color="#ffe1c5"
                    >
                      <!-- TODO : get receiveDate last index -->
                      <p style="color: #000">
                        แจ้งรับอุปกรณ์ติดตั้งเรือ
                        {{
                          formateDate(
                            data[indextr].accessoriesReceives[0].receiveDate
                          )
                        }}
                      </p>
                    </vs-chip>
                    <vs-chip
                      v-else-if="
                        data[indextr].status == 'ยืนยันการรับอุปกรณ์ติดตั้งเรือ'
                      "
                    >
                      ยืนยันการรับอุปกรณ์ติดตั้งเรือ
                    </vs-chip>
                    <vs-chip
                      v-else-if="data[indextr].status == 'รอการติดตั้งอุปกรณ์'"
                      color="#fc7e2a"
                    >
                      <p style="color: #fff">รอการติดตั้งอุปกรณ์</p>
                    </vs-chip>
                    <vs-chip
                      v-else-if="
                        data[indextr].status == 'รอยืนยันการติดตั้งอุปกรณ์'
                      "
                    >
                      <p style="color: #000">รอยืนยันการติดตั้งอุปกรณ์</p>
                    </vs-chip>
                    <vs-chip
                      v-else-if="
                        data[indextr].status == 'ยืนยันการติดตั้งอุปกรณ์'
                      "
                      color="#188d09"
                    >
                      <p style="color: #fff">ยืนยันการติดตั้งอุปกรณ์</p>
                    </vs-chip>

                    <!-- TODO ถ้า admin ยืนยันการลงทะเบียนเรือ ต้องดึงลายเซน สรรพสามิต ที่ยังไม่มีใน registrationForm นั้น $acl.check('hasRoleAdminOrSuperVisor') -->
                    <vs-dropdown-menu
                      v-if="
                        $acl.check('hasRoleAdminOrSuperVisor') &&
                        data[indextr].status == 'รอยืนยันการลงทะเบียนเรือ' &&
                        checkSignature(data[indextr].signatures)
                      "
                    >
                      <vs-dropdown-item
                        @click="
                          comfirmRegister(
                            data[indextr].id,
                            data[indextr].installations,
                            data[indextr].vessel
                          )
                        "
                      >
                        ยืนยันการลงทะเบียน
                      </vs-dropdown-item>
                      <vs-dropdown-item
                        @click="cancelRegister(data[indextr].id)"
                      >
                        ยกเลิกการลงทะเบียน
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                    <vs-dropdown-menu
                      v-else-if="
                        $acl.check('hasRoleAdmin') &&
                        data[indextr].status == 'รอยืนยันการลงทะเบียนเรือ'
                      "
                    >
                      <vs-dropdown-item
                        @click="cancelRegister(data[indextr].id)"
                      >
                        ยกเลิกการลงทะเบียน
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                    <vs-dropdown-menu
                      v-else-if="
                        $acl.check('hasRoleSuperVisor') &&
                        data[indextr].status == 'ยืนยันการลงทะเบียนเรือ' &&
                        !data[indextr].vessel.mmsi
                      "
                    >
                      <vs-dropdown-item
                        v-show="$acl.check('hasRoleCenter')"
                        @click="addMMSI(data[indextr], data[indextr].vessel)"
                      >
                        เพิ่ม MMSI
                      </vs-dropdown-item>
                      <vs-dropdown-item
                        @click="cancelRegister(data[indextr].id)"
                      >
                        ยกเลิกการลงทะเบียน
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                    <vs-dropdown-menu
                      v-else-if="
                        $acl.check('hasRoleAdminOrContractor') &&
                        data[indextr].status == 'แจ้งรับอุปกรณ์ติดตั้งเรือ'
                      "
                    >
                      <vs-dropdown-item
                        @click="
                          receiveEquipment(
                            data[indextr].id,
                            'ยืนยันการรับอุปกรณ์ติดตั้งเรือ'
                          )
                        "
                      >
                        รับอุปกรณ์
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                    <vs-dropdown-menu
                      v-else-if="
                        $acl.check('hasRoleAdminOrContractor') &&
                        data[indextr].status == 'รอการติดตั้งอุปกรณ์'
                      "
                    >
                      <!-- data[indextr].registrationBy == 'กรมสรรพสามิตพื้นที่' || (data[indextr].registrationBy == 'ผู้ดูแลระบบ' &&  -->
                      <vs-dropdown-item
                        @click="
                          equipmentInstall(
                            data[indextr].id,
                            data[indextr].installations[0].id,
                            'ยืนยันการติดตั้งอุปกรณ์'
                          )
                        "
                      >
                        ติดตั้งอุปกรณ์
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                    <vs-dropdown-menu
                      v-else-if="
                        $acl.check('hasRoleAdminOrContractor') &&
                        data[indextr].status == 'รอยืนยันการติดตั้งอุปกรณ์'
                      "
                    >
                      <vs-dropdown-item
                        @click="
                          confirmInstall(
                            data[indextr].id,
                            data[indextr].installations[0].id,
                            'ยืนยันการติดตั้งอุปกรณ์'
                          )
                        "
                      >
                        ยืนยันการติดตั้งอุปกรณ์
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </vs-td>

              <!-- <vs-td style="max-width: 175px" v-if="$acl.check('hasRoleSuperVisor')">
                <span>
                  <div v-if="
                    $acl.not.check('hasRoleAdmin') &&
                    data[indextr].status == 'รอยืนยันการลงทะเบียนเรือ' 
                  ">
                    data[indextr].registrationBy == 'เจ้าของเรือ' && 
                    <div v-if="checkSignature(data[indextr].signatures)">
                      <vs-button
                        type="flat"
                        color="primary"
                        @click="comfirmRegister(data[indextr].id, data[indextr].installations, data[indextr].vessel)"
                        style="width: 75px; padding: 10px 0px 10px 0px"
                      >
                        ยืนยัน
                      </vs-button>
                      <vs-button
                        type="flat"
                        color="danger"
                        @click="cancelRegister(data[indextr].id)"
                        style="width: 75px; padding: 10px 0px 10px 0px"
                        >ยกเลิก</vs-button
                      >
                    </div>
                  </div>
                   <div v-if="
                    $acl.check('hasRoleAdmin') &&
                    data[indextr].status == 'ยืนยันการลงทะเบียนเรือ' && 
                    !data[indextr].vessel.mmsi
                  ">
                    <vs-button
                      type="flat"
                      color="success"
                      @click="addMMSI(data[indextr].id, data[indextr].vessel)"
                    >
                      เพิ่ม MMSI
                    </vs-button>
                  </div>
                  <div
                    v-if="
                      data[indextr].registrationBy == 'กรมสรรพสามิตพื้นที่' ||
                      (data[indextr].registrationBy == 'ผู้ดูแลระบบ' &&
                        data[indextr].status == 'รอยืนยันการลงทะเบียนเรือ')
                    "
                  >
                    <vs-button
                      type="flat"
                      color="primary"
                      @click="
                        comfirmRegister(
                          data[indextr].id,
                          data[indextr].installations,
                          data[indextr].vessel
                        )
                      "
                      >ยืนยัน</vs-button
                    >
                    <vs-button
                      type="flat"
                      color="danger"
                      @click="cancelRegister(data[indextr].id)"
                      >ยกเลิก</vs-button
                    >
                  </div> //อาจจะไม่เอา 
                  <vs-button
                    type="flat"
                    color="primary"
                    v-if="data[indextr].status == 'แจ้งรับอุปกรณ์ติดตั้งเรือ'"
                    @click="
                      receiveEquipment(
                        data[indextr].id,
                        'ยืนยันการรับอุปกรณ์ติดตั้งเรือ'
                      )
                    "
                  >
                    รับอุปกรณ์
                  </vs-button>

                  <vs-button
                    type="flat"
                    color="warning"
                    v-if="
                      data[indextr].registrationBy == 'กรมสรรพสามิตพื้นที่' ||
                      (data[indextr].registrationBy == 'ผู้ดูแลระบบ' &&
                        data[indextr].status == 'รอการติดตั้งอุปกรณ์')
                    "
                    @click="
                      equipmentInstall(
                        data[indextr].id,
                        data[indextr].installations[0].id,
                        'ยืนยันการติดตั้งอุปกรณ์'
                      )
                    "
                  >
                    ติดตั้งอุปกรณ์
                  </vs-button>

                  <vs-button
                    type="flat"
                    color="warning"
                    v-if="data[indextr].status == 'รอยืนยันการติดตั้งอุปกรณ์'"
                    @click="
                      confirmInstall(
                        data[indextr].id,
                        data[indextr].installations[0].id,
                        'ยืนยันการติดตั้งอุปกรณ์'
                      )
                    "
                  >
                    ยืนยันการติดตั้งอุปกรณ์
                  </vs-button>
                </span>
              </vs-td> -->

              <vs-td style="width: 15px" v-if="$acl.check('hasRoleSuperVisor')">
                <vs-dropdown color="#c80948">
                  <!-- 329972 -->
                  <vs-button
                    type="flat"
                    icon-pack="feather"
                    icon="icon-printer"
                    v-if="data[indextr].registerBy != 'เจ้าของเรือ'"
                  >
                    พิมพ์
                  </vs-button>
                  <vs-dropdown-menu style="min-width: 17rem">
                    <vs-dropdown-item
                      @click="print(data[indextr].id, 'ps0508-a')"
                      v-if="data[indextr].vessel.type != 'vessel'"
                    >
                      แบบฟอร์ม ภส.05-08(ก)
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="print(data[indextr].id, 'ps0508-b')"
                      v-else
                    >
                      แบบฟอร์ม ภส.05-08(ข)
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="print(data[indextr].id, 'ps05081')"
                      v-if="
                        data[indextr].vessel.type == 'forwardTanker' &&
                        data[indextr].vessel.oils.length != 0
                      "
                    >
                      แบบฟอร์ม ภส.05-08/1
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="print(data[indextr].id, 'ps05082')"
                      v-if="
                        (data[indextr].vessel.oils.length != 0 &&
                          data[indextr].vessel.type == 'tanker') ||
                        data[indextr].vessel.type == 'serialTanker'
                      "
                    >
                      แบบฟอร์ม ภส.05-08/2
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="print(data[indextr].id, 'receive')"
                      v-if="
                        data[indextr].status == 'รอการติดตั้งอุปกรณ์' ||
                        data[indextr].status == 'รอยืนยันการติดตั้งอุปกรณ์' ||
                        data[indextr].status == 'ยืนยันการติดตั้งอุปกรณ์'
                      "
                    >
                      แบบฟอร์มการรับอุปกรณ์
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="print(data[indextr].id, 'install')"
                      v-if="
                        data[indextr].status == 'รอยืนยันการติดตั้งอุปกรณ์' ||
                        data[indextr].status == 'ยืนยันการติดตั้งอุปกรณ์'
                      "
                    >
                      แบบฟอร์มการติดตั้งอุปกรณ์
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="printReparationInstall(data[indextr].vessel.reparationVessels, 'reparation install')"
                      v-if="
                        checkReparationInstall(data[indextr].vessel.reparationVessels)
                      "
                    >
                      แบบฟอร์มการติดตั้งอุปกรณ์ (แจ้งซ่อม)
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <div class="demo-alignment">
      <vs-popup
        title="ยืนยันการรับอุปกรณ์ติดตั้งเรือ"
        :active.sync="popupReceive"
      >
        <registration-receive
          v-if="popupReceive"
          @onClosedRecieve="onClosedRecieve"
          :dataVessel="passData"
          :active="popupReceive"
        ></registration-receive>
      </vs-popup>
    </div>

    <div class="demo-alignment">
      <vs-popup
        id="popup-signature"
        title="ยืนยันการติดตั้งอุปกรณ์"
        :active.sync="popupInstall"
      >
        <registration-install
          v-if="popupInstall"
          @onClosedInstall="onClosedInstall"
          :dataVessel="passInfo"
          :active="popupInstall"
        ></registration-install>
      </vs-popup>
    </div>

    <div class="demo-alignment">
      <vs-popup
        id="popup-signature"
        title="ยืนยันการติดตั้งอุปกรณ์"
        :active.sync="popupConfirmInstall"
      >
        <registration-confirm-install
          v-if="popupConfirmInstall"
          @onClosedConfirmInstall="onClosedConfirmInstall"
          :dataVessel="passInfo"
          :active="popupConfirmInstall"
        ></registration-confirm-install>
      </vs-popup>
    </div>

    <div class="demo-alignment">
      <vs-popup
        id="popup-signature"
        class="popup"
        title="ลายเซนต์"
        :active.sync="signaturePopup"
      >
        <registration-popup
          @onClosedSignature="onClosedSignature"
          :passValue="passId"
        ></registration-popup>
      </vs-popup>
    </div>

    <div class="demo-alignment">
      <vs-popup
        id="popup-selected-data-for-excel"
        title="เลือกหัวข้อสำหรับการ export excel"
        :active.sync="isActiveSelectExcelPopup"
      >
        <ul class="flex justify-center pl-20">
          <vs-row class="my-2">
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['Call Sign']"
                  :vs-value="'vessel.subName'"
                  >Call Sign</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['MMSI']"
                  :vs-value="'vessel.mmsi'"
                  >MMSI</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ทะเบียนเรือสรรพสามิต']"
                  :vs-value="'vessel.exciseOilCode'"
                  >ทะเบียนเรือสรรพสามิต</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['หมายเลขทะเบียนเรือ']"
                  :vs-value="'vessel.registrationNumber'"
                  >หมายเลขทะเบียนเรือ</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ชื่อเรือ']"
                  :vs-value="'vessel.name'"
                  >ชื่อเรือ</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ประเภทเรือ']"
                  :vs-value="
                    JSON.stringify({
                      field: 'vessel.type',
                      callback: function type(value) {
                        const type =
                          value == 'vessel'
                            ? 'เรือประมง'
                            : value == 'tanker'
                            ? 'เรือบรรทุกน้ำมัน'
                            : value == 'serialTanker'
                            ? 'เรือบรรทุกน้ำมันต่อเนื่อง'
                            : 'เรือสถานีบริการน้ำมัน';
                        return type;
                      }.toString(),
                    })
                  "
                >
                  ประเภทเรือ
                </vs-checkbox>
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ชื่อเจ้าของเรือ']"
                  :vs-value="
                    JSON.stringify({
                      field: 'registration.createdBy',
                      callback: function createdBy(value) {
                        let owner = '';
                        if (value.personType == 'บุคคลทั่วไป') {
                          owner = `${value.title}${value.firstName} ${value.lastName}`;
                        } else {
                          owner = `${value.certificateOperateName}`;
                        }
                        return owner;
                      }.toString(),
                    })
                  "
                  >ชื่อเจ้าของเรือ</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['เบอร์ติดต่อ']"
                  :vs-value="
                    JSON.stringify({
                      field: 'registration.createdBy',
                      type: 'text',
                      callback: function phoneNumber(value) {
                        let phoneNumber = '';
                        if (value.personType == 'บุคคลทั่วไป') {
                          phoneNumber = `${value.phoneNumber}`;
                        } else {
                          phoneNumber = `${value.certificatePhoneNumber}`;
                        }
                        return phoneNumber;
                      }.toString(),
                    })
                  "
                  >เบอร์ติดต่อ</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ที่อยู่ตามทะเบียนเรือ']"
                  :vs-value="
                    JSON.stringify({
                      field: 'registration',
                      callback: function address(value) {
                        const data = value.createdBy;
                        let address = '';
                        if (data.personType == 'บุคคลทั่วไป') {
                          address = `${data.buildingName} ${
                            data.address
                          } ชั้นที่${data.floor ? data.floor : '-'} หมู่ที่${
                            data.villageNumber ? data.villageNumber : '-'
                          } ตรอก${data.lane ? data.lane : '-'} ถนน${
                            data.road ? data.road : '-'
                          } ตำบล${data.subDistrict} อำเภอ${
                            data.district
                          } จังหวัด${data.province} ${data.postalCode}`;
                        } else {
                          address = `${data.certificateEstablishmentName} ${
                            data.address
                          } ชั้นที่${data.floor ? data.floor : '-'} หมู่ที่${
                            data.certificateVillageNumber
                              ? data.certificateVillageNumber
                              : '-'
                          } ตรอก${
                            data.certificateLane ? data.certificateLane : '-'
                          } ถนน${
                            data.certificateRoad ? data.certificateRoad : '-'
                          } ตำบล${data.certificateSubDistrict} อำเภอ${
                            data.certificateDistrict
                          } จังหวัด${data.certificateProvince} ${
                            data.certificatePostalCode
                          }`;
                        }
                        return address;
                      }.toString(),
                    })
                  "
                  >ที่อยู่ตามทะเบียนเรือ</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['เขตพื้นที่']"
                  :vs-value="'vessel.zone.province'"
                  >เขตพื้นที่</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ลงทะเบียนโดย']"
                  :vs-value="'registrationBy'"
                  >ลงทะเบียนโดย</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['วันที่ลงทะเบียน']"
                  :vs-value="
                    JSON.stringify({
                      field: 'documentDate',
                      callback: function documentDate(value) {
                        if (value) {
                          const date = new Date(value);
                          const yyyy = date.getFullYear() + 543;
                          let mm = date.getMonth() + 1; // Months start at 0!
                          let dd = date.getDate();

                          if (dd < 10) dd = '0' + dd;
                          if (mm < 10) mm = '0' + mm;

                          const formattedToday = dd + '/' + mm + '/' + yyyy;
                          return formattedToday;
                        } else {
                          return '';
                        }
                      }.toString(),
                    })
                  "
                  >วันที่ลงทะเบียน</vs-checkbox
                >
                <!-- moment(date).add(543, 'year').format('DD/MM/YYYY') -->
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['สถานะ']"
                  :vs-value="'status'"
                  >สถานะ</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ตันกรอส']"
                  :vs-value="'vessel.tonGross'"
                  >ตันกรอส</vs-checkbox
                >
              </li>
            </vs-col>
            <vs-col vs-type="flex" vs-w="3" class="my-2">
              <li>
                <vs-checkbox
                  v-model="selectedDataForExcel['ความจุถังน้ำมัน']"
                  :vs-value="
                    JSON.stringify({
                      field: 'vessel',
                      callback: function capacity(value) {
                        const capacity =
                          value.type == 'vessel'
                            ? value.capacity
                            : value.capacityForSale;
                        return capacity;
                      }.toString(),
                    })
                  "
                  >ความจุถังน้ำมัน</vs-checkbox
                >
              </li>
            </vs-col>
          </vs-row>
        </ul>

        <div class="flex justify-center my-5">
          <DownloadExcel
            header="รายชื่อเรือในโครงการเพิ่มประสิทธิภาพระบบควบคุม ตรวจสอบ และติดตามการจำหน่ายน้ำมันดีเซลสำหรับชาวประมงในเขตต่อเนื่องของราชอาณาจักร"
            :data="vessels"
            :fields="json_fields"
            :stringifyLongNum="true"
            name="fisheries-oil-registration.xls"
          >
            <vs-button color="primary" type="filled" align="center" class="mx-1"
              >เลือกทั้งหมด</vs-button
            >
          </DownloadExcel>
          <DownloadExcel
            :data="vessels"
            :fields="json_fields_new"
            :stringifyLongNum="true"
            name="fisheries-oil-registration.xls"
            v-if="isConfirmSelectedDataForExcel"
          >
            <vs-button
              @click="confirmSelectDataForExcel()"
              color="primary"
              type="filled"
              align="center"
              class="mx-1"
              >ยืนยัน</vs-button
            >
          </DownloadExcel>
          <vs-button
            v-show="isConfirmSelectedDataForExcel"
            @click="
              isConfirmSelectedDataForExcel = false;
              clearSelectDataForExcel();
            "
            color="danger"
            type="filled"
            align="center"
            class="mx-1"
            >ล้าง</vs-button
          >
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import RegistrationReceive from "./registrationReceive.vue";
import RegistrationInstall from "./registrationInstall.vue";
import RegistrationConfirmInstall from "./registrationConfirmInstall.vue";
import Swal from "sweetalert2";
import moment from "moment";
import { ENDPOINT } from "../../../constants/endpoint.js";
import RegistrationPopup from "../registration-popup/RegistrationPopup.vue";
import VueSignaturePad from "vue-signature-pad";
import { AclRule } from "vue-acl";
import DownloadExcel from "vue-json-excel";
import { ValueAxisDataItem } from "@amcharts/amcharts4/charts";
import AdvanceSearch from "../../../components/vx-card/AdvanceSearch.vue";
import { formatNumber } from "@/utils/index";
import { mapState } from "vuex";
import CallbackVue from "../../Callback.vue";
// import selectExportVessel from "./selectExportVessel.vue";

export default {
  name: "VesselIndex",
  components: {
    RegistrationInstall,
    RegistrationReceive,
    RegistrationConfirmInstall,
    RegistrationPopup,
    VueSignaturePad,
    DownloadExcel,
    AdvanceSearch,
    // selectExportVessel,
  },
  computed: {
    isLocalRule() {
      return new AclRule("create").generate();
    },
  },
  data() {
    return {
      descriptionItems: [10, 25, 50, 100],
      formatNumber,
      name: "tony stark",
      cardId: "1234567890123",
      phoneNumber: "091-747-9231",
      eMail: "test123@gmail.com",
      postalCode: "40000",
      district: "เชียงยืน",
      subDistrict: "เชียงยืน",
      province: "มหาสารคาม",
      homeNumber: "1234",
      chkStatus: true,
      popupConfirmInstall: false,
      popupInstall: false,
      popupReceive: false,
      status: [
        { text: "รอยืนยันการลงทะเบียนเรือ", value: 1 },
        { text: "ยืนยันการลงทะเบียนเรือ", value: 2 },
        { text: "แจ้งรับอุปกรณ์ติดตั้งเรือ", value: 3 },
        { text: "ยืนยันการรับอุปกรณ์ติดตั้งเรือ", value: 4 },
        { text: "รอการติดตั้งอุปกรณ์", value: 5 },
        { text: "รอยืนยันการติดตั้งอุปกรณ์", value: 6 },
        { text: "ยืนยันการติดตั้งอุปกรณ์", value: 7 },
      ],
      registerInfo: [
        { text: "เจ้าของเรือ", value: 1 },
        { text: "กรมสรรพสามิตพื้นที่", value: 2 },
      ],
      search: {
        mmsi: "",
        name: "",
        status: "",
        registerBy: "",
      },
      selected: [],
      vesselsData: [],
      passInfo: null,
      passData: null,
      passId: null,
      signaturePopup: false,
      isSignaturePad: false,
      companySealImage: null,
      supervisorType: localStorage.getItem("exciseType"),
      isConfirmedRegistration: true,
      isDownload: false,
      form: {
        regions: [],
      },
      regions: [
        { name: "Call Sign" },
        { name: "MMSI" },
        { name: "ทะเบียนเรือสรรพสามิต" },
        { name: "หมายเลขทะเบียนเรือ" },
        { name: "ชื่อเรือ" },
        { name: "ประเภทเรือ" },
        { name: "ชื่อเจ้าของเรือ" },
        { name: "เบอร์ติดต่อ" },
        { name: "ที่อยู่ตามทะเบียนเรือ" },
        { name: "เขตพื้นที่" },
        { name: "ลงทะเบียนโดย" },
        { name: "วันที่ลงทะเบียน" },
        { name: "สถานะ" },
      ],
      field: {},
      json_fields: {
        ลำดับ: "runNumber",
        "Call Sign": "vessel.subName",
        MMSI: "vessel.mmsi",
        ทะเบียนเรือสรรพสามิต: "vessel.exciseOilCode",
        หมายเลขทะเบียนเรือ: "vessel.registrationNumber",
        ชื่อเรือ: "vessel.name",
        ตันกรอส: "vessel.tonGross",
        ประเภทเรือ: {
          field: "vessel.type",
          callback: (value) => {
            const type =
              value == "vessel"
                ? "เรือประมง"
                : value == "tanker"
                ? "เรือบรรทุกน้ำมัน"
                : value == "serialTanker"
                ? "เรือบรรทุกน้ำมันต่อเนื่อง"
                : "เรือสถานีบริการน้ำมัน";
            return type;
          },
        },
        ชื่อเจ้าของเรือ: {
          field: "registration.createdBy",
          callback: (value) => {
            let owner = "";
            if (value.personType == "บุคคลทั่วไป") {
              owner = `${value.title}${value.firstName} ${value.lastName}`;
            } else {
              owner = `${value.certificateOperateName}`;
            }
            return owner;
          },
        },
        เบอร์ติดต่อ: {
          field: "registration.createdBy",
          type: "text",
          callback: (value) => {
            let phoneNumber = "";
            if (value.personType == "บุคคลทั่วไป") {
              phoneNumber = `${value.phoneNumber}`;
            } else {
              phoneNumber = `${value.certificatePhoneNumber}`;
            }
            // console.log("phoneNumber ", phoneNumber);
            return phoneNumber;
          },
        },
        ที่อยู่ตามทะเบียนเรือ: {
          field: "registration",
          callback: (value) => {
            const data = value.createdBy;
            let address = "";
            if (data.personType == "บุคคลทั่วไป") {
              address = `${data.buildingName} ${data.address} ชั้นที่${
                data.floor ? data.floor : "-"
              } หมู่ที่${data.villageNumber ? data.villageNumber : "-"} ตรอก${
                data.lane ? data.lane : "-"
              } ถนน${data.road ? data.road : "-"} ตำบล${
                data.subDistrict
              } อำเภอ${data.district} จังหวัด${data.province} ${
                data.postalCode
              }`;
            } else {
              address = `${data.certificateEstablishmentName} ${
                data.address
              } ชั้นที่${data.floor ? data.floor : "-"} หมู่ที่${
                data.certificateVillageNumber
                  ? data.certificateVillageNumber
                  : "-"
              } ตรอก${data.certificateLane ? data.certificateLane : "-"} ถนน${
                data.certificateRoad ? data.certificateRoad : "-"
              } ตำบล${data.certificateSubDistrict} อำเภอ${
                data.certificateDistrict
              } จังหวัด${data.certificateProvince} ${
                data.certificatePostalCode
              }`;
            }
            return address;
          },
        },
        เขตพื้นที่: "vessel.zone.province",
        ลงทะเบียนโดย: "registrationBy",
        วันที่ลงทะเบียน: {
          field: "documentDate",
          callback: (value) => {
            return this.formateDate(value);
          },
        },
        สถานะ: "status",
        ความจุถังน้ำมัน: {
          field: "vessel",
          callback: (value) => {
            const capacity =
              value.type == "vessel" ? value.capacity : value.capacityForSale;
            return capacity;
          },
        },
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      countVessel: 0,
      countTanker: 0,
      countSerialTanker: 0,
      countForwardTanker: 0,
      isAdvancedSearch: false,
      advancedSearch: null,
      value1: "",
      value2: "",
      isActiveSelectExcelPopup: false,
      isConfirmSelectedDataForExcel: false,
      selectedDataForExcel: {
        ลำดับ: "runNumber",
      },
      json_fields_new: null,
    };
  },
  mounted() {
    this.getData();
    console.log("supervisorType ", this.supervisorType);
    // console.log("index ", this.vessels);

    this.vesselsData = this.vessels//[...this.vessels]
    console.log("vesselsData ", this.vesselsData);

    this.$store.dispatch("rts/getVesselGroupFishing");
    this.$store.dispatch("rts/getVesselGroupTanker");

  },
  watch: {
    vessels(newVal, oldVal) {
      // if (newVal != oldVal) {
      // for (const [index, vessel] of newVal.entries()) {
      //   vessel.runNumber = index + 1;
      // }

      // this.countVessel = _.filter(newVal, (o) => {
      //   return o.type == "vessel";
      // }).length;

      // this.countTanker = _.filter(newVal, (o) => {
      //   return o.type == "tanker";
      // }).length;

      // this.countSerialTanker = _.filter(newVal, (o) => {
      //   return o.type == "serialTanker";
      // }).length;

      // this.countForwardTanker = _.filter(newVal, (o) => {
      //   return o.type == "forwardTanker";
      // }).length;

      // this.arrays = _.flattenDepth(this.vessels, 1);

      this.vesselsData = newVal

      //  return _.orderBy(newVal, ['runNumber'], ['asc']);

      console.log("this.vesselsData ", this.vesselsData);
      // console.log("this.countVessel >> ", this.countVessel);
      // console.log("this.countTanker >> ", this.countTanker);
      // console.log("this.countSerialTanker >> ", this.countSerialTanker);
      // console.log("this.countForwardTanker >> ", this.countForwardTanker);
      // }
    },
    selectedDataForExcel(newVal, oldVal) {
      // this.selectedDataForExcel['ลำดับ']  = "runNumber"
      // console.log(!_.isEmpty(newVal));
      if (!_.isEmpty(newVal)) {
        this.isConfirmSelectedDataForExcel = true;
      }
    },
    isConfirmSelectedDataForExcel(newVal, oldVal) {
      if (!newVal) {
        this.selectedDataForExcel["ลำดับ"] = "runNumber";
      }
    },
  },
  computed: {
    ...mapState({
      vessels: (state) => state.vessels.vessels,
    }),
  },
  methods: {
    async getData(type) {
      const status = localStorage.getItem("registrationStatus");
      console.log("status = ", status);
      const mmsi = localStorage.getItem("mmsi");
      this.$vs.loading({});
      await this.$store.dispatch("vessels/setVessels", {
        advancedSearch: this.advancedSearch,
        status,
        mmsi,
        type,
      });
      this.$vs.loading.close();
      localStorage.removeItem("registrationStatus");
      localStorage.removeItem("mmsi");

      if (this.vessels.length > 100) {
        this.descriptionItems.push(this.vessels.length);
      }
    },
    sort(x) {
      const y = _.orderBy(x, ["documentDate"], ["asc"]);
      return y;
    },
    detailVessel(id) {
      //  this.$router.push(`/vessel/detail/${id}`)
      console.log("detailVessel>>>> ", id);
      window.open(`/admin/vessel/detail/${id}`, "_blank");
    },
    confirmRecieve(id, value) {
      Swal.fire({
        title: "ยืนยันการลงทะเบียนเรือ",
        text: "",
        icon: "question",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        preConfirm: () => {
          var payload = {
            id: id,
            value: value,
          };
          this.$store.dispatch("vessels/setChangeStatus", payload);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "success",
            title: "ยืนยันการลงทะเบียนเรือเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {});
        }
      });
    },
    cancelRecieve(id, value) {
      Swal.fire({
        title: "ยกเลิกการยืนยันทะเบียนเรือ",
        text: "",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        preConfirm: () => {
          var payload = {
            id: id,
            value: value,
          };
          this.$store.dispatch("vessels/setChangeStatus", payload);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "success",
            title: "ยกเลิกการยืนยันทะเบียนเรือเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {});
        }
      });
    },
    equipmentInstall(registrationId, installId, value) {
      this.popupInstall = true;

      this.passInfo = { registrationId, installId, value };
    },
    onClosedInstall(val) {
      this.popupInstall = false;
      this.getData();
    },
    confirmInstall(registrationId, installId, value) {
      this.popupConfirmInstall = true;
      this.passInfo = { registrationId, value };
    },
    onClosedConfirmInstall(val) {
      this.popupConfirmInstall = false;
      this.getData();
    },
    onClosedSignature(val) {
      this.signaturePopup = false;
    },
    async cancelRegister(id) {
      Swal.fire({
        title: "ยืนยันยกเลิกการลงทะเบียน",
        text: "",
        icon: "question",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        preConfirm: () => {
          const data = {
            registrationId: id,
            status: "ยกเลิกการลงทะเบียน",
            mmsi: null,
          };
          this.$store.dispatch("vessels/setChangeStatus", data);
        },
      });
    },
    async comfirmRegister(id, installations, vessel) {
      await this.$store.dispatch("users/setUserById", {
        id: localStorage.getItem("accessUserId"),
      });

      const user = await this.$store.state.users.user;
      console.log("id สรรพสามิตพื้นที่ ===> ", id);

      if (this.$acl.check("hasRoleAdmin")) {
        Swal.fire({
          title: "ยืนยันการลงทะเบียน",
          text: "",
          icon: "question",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showCancelButton: true,
          html:
            "<b>เจ้าพนักงานสรรพสามิต</b><br></br>" +
            '<label for="supervisorName">ชื่อ:</label><input id="supervisorName" class="swal2-input w-3/4">' +
            '<label for="supervisorPosition">ตำแหน่ง:</label><input id="supervisorPosition" class="swal2-input w-2/3">' +
            '<label for="supervisorApprovedDate">วันที่ยืนยันเอกสาร:</label><input id="supervisorApprovedDate" type="date" class="swal2-input w-1/2">' +
            "<br></br><hr></hr><br></br>" +
            "<b>คำสั่ง</b><br></br>" +
            '<label for="supervisorHeaderName">ชื่อ:</label><input id="supervisorHeaderName" class="swal2-input w-3/4">' +
            '<label for="supervisorHeaderPosition">ตำแหน่ง:</label><input id="supervisorHeaderPosition" class="swal2-input w-2/3">' +
            '<label for="supervisorHeaderApprovedDate">วันที่ยืนยันเอกสาร:</label><input id="supervisorHeaderApprovedDate" type="date" class="swal2-input w-1/2">',
          preConfirm: () => {
            const data = {
              registrationId: id,
              status: "ยืนยันการลงทะเบียนเรือ",
              fileName: user.signatureName,
              detail: null,
              installations,
              isAdmin: this.$acl.check("hasRoleAdmin"),
              supervisorName: document.getElementById("supervisorName").value,
              supervisorPosition:
                document.getElementById("supervisorPosition").value,
              supervisorApprovedDate: document.getElementById(
                "supervisorApprovedDate"
              ).value,
              supervisorHeaderName: document.getElementById(
                "supervisorHeaderName"
              ).value,
              supervisorHeaderPosition: document.getElementById(
                "supervisorHeaderPosition"
              ).value,
              supervisorHeaderApprovedDate: document.getElementById(
                "supervisorHeaderApprovedDate"
              ).value,
            };
            if (user.signatureName != "" && user.signatureName != null) {
              this.$store.dispatch("vessels/setChangeStatus", data);
            } else {
              this.passId = {
                id,
                name: "ยืนยันการลงทะเบียนเรือ",
                type: "registration_user",
                data,
              };
              this.signaturePopup = !this.signaturePopup;
            }
          },
        });
      } else {
        if (this.supervisorType != "APPROVER") {
          // if (vessel.mmsi) {
          //   var mmsi = vessel.mmsi
          // } else {
          //   var { value: mmsi } =  await Swal.fire({
          //     title: "ยืนยันการลงทะเบียนเรือ",
          //     input: "text",
          //     inputLabel: "MMSI",
          //     confirmButtonText: 'ต่อไป',
          //     cancelButtonText: 'ยกเลิก',
          //     showCancelButton: true,
          //     inputValidator: (value) => {
          //       if (!value) {
          //         return "กรุณากรอก MMSI เพื่อยืนยันการลงทะเบียนเรือ";
          //       }
          //       if (value.length != 9) {
          //         return "กรุณากรอก MMSI ให้ครบ 9 หลักเท่านั้น";
          //       }
          //       if (!Number(value)) {
          //         return "กรุณากรอก MMSI เป็นตัวเลขเท่านั้น";
          //       }
          //     },
          //   })
          // }

          // if (mmsi) {//&& registrationExcise //เลขทะเบียนเรือสรรพสามิต
          var { value: datail } = await Swal.fire({
            title: "ความเห็นเจ้าพนักงาน",
            input: "textarea",
            inputPlaceholder: "ความเห็นเจ้าพนักงาน(ไม่จำเป็นต้องกรอก)",
            showCancelButton: false,
            confirmButtonText: "ต่อไป",
          }).then((result) => {
            Swal.fire({
              title: "ยืนยันการลงทะเบียน",
              text: "",
              icon: "question",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก",
              showCancelButton: true,
              preConfirm: () => {
                const data = {
                  registrationId: id,
                  status: "ยืนยันการลงทะเบียนเรือ",
                  fileName: user.signatureName,
                  // mmsi,
                  detail: result.value,
                  installations,
                  // registrationExcise //เลขทะเบียนเรือสรรพสามิต
                };
                if (user.signatureName != "" && user.signatureName != null) {
                  this.$store.dispatch("vessels/setChangeStatus", data);
                } else {
                  this.passId = {
                    id,
                    name: "ยืนยันการลงทะเบียนเรือ",
                    type: "registration_user",
                    data,
                  };
                  this.signaturePopup = !this.signaturePopup;
                }
              },
            });
          });
          // }
        } else {
          Swal.fire({
            title: "ยืนยันการลงทะเบียน",
            text: "",
            icon: "question",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showCancelButton: true,
            preConfirm: () => {
              const data = {
                registrationId: id,
                status: "ยืนยันการลงทะเบียนเรือ",
                fileName: user.signatureName,
                mmsi: null,
                detail: null,
                installations,
              };
              if (user.signatureName != "" && user.signatureName != null) {
                this.$store.dispatch("vessels/setChangeStatus", data);
              } else {
                this.passId = {
                  id,
                  name: "ยืนยันการลงทะเบียนเรือ",
                  type: "registration_user",
                  data,
                };
                this.signaturePopup = !this.signaturePopup;
              }
            },
          });
        }
      }

      // เลขทะเบียนเรือสรรพสามิต
      // var { value: registrationExcise } = await Swal.fire({
      //   title: "ยืนยันการลงทะเบียนเรือ",
      //   input: "number",
      //   inputLabel: "เลขทะเบียนเรือสรรพสามิต",
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return "กรุณากรอก เลขทะเบียนเรือสรรพสามิต เพื่อยืนยันการลงทะเบียนเรือ";
      //     }
      //     if (value.length != 10) {
      //       return "กรุณากรอก เลขทะเบียนเรือสรรพสามิต ให้ครบ 10 หลักเท่านั้น";
      //     }
      //   },
      // });
    },
    async receiveEquipment(id, value) {
      this.passData = { id, value };
      console.log("data pss :", this.passData);
      this.popupReceive = true;
    },
    onClosedRecieve() {
      this.popupReceive = false;
      this.getData();
    },
    formateDate(date) {
      // console.log('formateDate :::: ', date);
      return date && moment(date).add(543, "year").format("DD/MM/YYYY");
    },
    print(id, type) {
      window.open(`/admin/vessel/${type}/print/${id}`, "_blank");
    },
    checkReparationInstall(reparation){
      const findLast = _.findLast(reparation, (r)=>{
        return r.status == "ยืนยันการติดตั้งอุปกรณ์" ;
      });
      return findLast ? true : false
    },
    printReparationInstall(reparation){
      const findLast = _.findLast(reparation, (r)=>{
        return r.status == "ยืนยันการติดตั้งอุปกรณ์" ;
      });
      if (findLast) {
        window.open(`/admin/reparation/install/print/${findLast.id}`, "_blank");
      }  
        
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
      this.isSignaturePad = false;
    },
    convertDataUrlToBlob(dataUrl) {
      const arr = dataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    },
    checkSignature(signatures) {
      this.supervisorType == "null" && (this.supervisorType = null);
      let signaturesSupervisors = [];
      signatures.map((signature) => {
        // console.log(signature.user.exciseType, this.supervisorType);
        if (signature.type == "เจ้าพนักงานสรรพสามิต") {
          if (signature.user.exciseType == this.supervisorType) {
            signaturesSupervisors.push(signature);
          }
        }
      });
      // console.log(signaturesSupervisors.length);
      return signaturesSupervisors.length != 1;
    },
    async addMMSI(registrationForm, vessel) {
      // console.log(registrationForm.registration.createdBy, vessel);
      const ownerVessel = registrationForm.registration.createdBy;
      // เลขMMSI
      var { value: mmsi } = await Swal.fire({
        title: "ยืนยันการเพิ่ม MMSI",
        input: "text",
        inputLabel: "MMSI",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "กรุณากรอก MMSI";
          }
          if (value.length != 9) {
            return "กรุณากรอก MMSI ให้ครบ 9 หลักเท่านั้น";
          }
        },
      });

      if (mmsi) {
        await this.$store.dispatch("rts/getRtsVesselsByMMSI", {
          mmsi,
          vessel,
          ownerVessel,
        });
        this.getData();
      }
    },
    printPdf() {
      window.open(`/admin/vessel/pdf`, "_blank");
    },
    confirmSelectDataForExcel() {
      if (_.isEmpty(this.selectedDataForExcel)) {
        Swal.fire({
          target: document.getElementById("popup-selected-data-for-excel"),
          icon: "warning",
          title: "เกิดข้อผิดพลาด",
          text: "โปรดเลือกหัวข้อมาอย่างน้อย 1 หัวข้อ",
          showConfirmButton: false,
        });
        this.isConfirmSelectedDataForExcel = false;
      } else {
        const a = { ...this.selectedDataForExcel };
        a["ประเภทเรือ"] &&
          (this.selectedDataForExcel["ประเภทเรือ"] = this.convertDataForExcel(
            JSON.parse(a["ประเภทเรือ"])
          ));
        a["ชื่อเจ้าของเรือ"] &&
          (this.selectedDataForExcel["ชื่อเจ้าของเรือ"] =
            this.convertDataForExcel(JSON.parse(a["ชื่อเจ้าของเรือ"])));
        a["เบอร์ติดต่อ"] &&
          (this.selectedDataForExcel["เบอร์ติดต่อ"] = this.convertDataForExcel(
            JSON.parse(a["เบอร์ติดต่อ"])
          ));
        a["ที่อยู่ตามทะเบียนเรือ"] &&
          (this.selectedDataForExcel["ที่อยู่ตามทะเบียนเรือ"] =
            this.convertDataForExcel(JSON.parse(a["ที่อยู่ตามทะเบียนเรือ"])));
        a["วันที่ลงทะเบียน"] &&
          (this.selectedDataForExcel["วันที่ลงทะเบียน"] =
            this.convertDataForExcel(JSON.parse(a["วันที่ลงทะเบียน"])));
        a["ความจุถังน้ำมัน"] &&
          (this.selectedDataForExcel["ความจุถังน้ำมัน"] =
            this.convertDataForExcel(JSON.parse(a["ความจุถังน้ำมัน"])));

        const isNotNull = _.omitBy(this.selectedDataForExcel, _.isNull);
        this.json_fields_new = isNotNull;
        this.isConfirmSelectedDataForExcel = true;
      }
    },
    convertDataForExcel(data) {
      if (data) {
        const newData = new Function("return " + data.callback)();
        data.callback = newData;
        return data;
      }
    },
    clearSelectDataForExcel() {
      this.isConfirmSelectedDataForExcel = false;
      this.selectedDataForExcel = {};
      this.json_fields_new = null;
    },
    async onClickChipVesselType(type) {
      if(type == 'all'){
        for (const [index, vessel] of this.vessels.entries()) {
          vessel.runNumber = index + 1;
        }
        this.vesselsData = this.vessels
      } else {
        const data = _.filter(this.vessels, (o) => {
          return o.type == type;
        });

        for (const [index, vessel] of data.entries()) {
          vessel.runNumber = index + 1;
        }

        this.vesselsData = data
      }
      console.log("onClickChipVesselType vessel >>> ", this.vesselsData);
    },
  },
};
</script>

<style lang="css" scoped></style>
